import { Link } from 'react-router-dom';
import { business } from '../../data/business';
import { dishes } from '../../data/dishes';
import { CallLink, OrderLink } from './links';

const EXPLORE = [
  { label: 'Full menu', to: '/menu' },
  { label: 'Thai street food', to: '/thai-street-food-seattle' },
  { label: 'Vegetarian Thai', to: '/vegetarian-thai-seattle' },
  { label: 'Near UW', to: '/near-uw' },
  { label: 'Blog', to: '/blog' },
];

const SOCIAL = [
  { label: 'Instagram', href: business.sameAs[0] },
  { label: 'Facebook', href: business.sameAs[1] },
  { label: 'Yelp', href: business.sameAs[2] },
];

/**
 * Dark footer. Keeps the descriptive internal links the previous footer gave
 * every dish page and landing page, so the redesign costs no crawl paths.
 */
const SpFooter = () => (
  <footer className="sp-footer sp-dark">
    <div className="sp-wrap">
      <div className="sp-foot-grid">
        <div className="sp-foot-brand">
          <span className="sp-logo">
            <img
              src="/assets/images/optimized/ThaprachanLogo.webp"
              alt="Thaprachan Thai logo: a river boat under a gold sun"
              loading="lazy"
              width={72}
              height={72}
            />
          </span>
          <p className="sp-foot-tagline">Where great food meets good vibes.</p>
          <OrderLink />
        </div>
        <div className="sp-foot-col sp-wide">
          <h3>Visit</h3>
          <span>
            {business.address.street}
            <br />
            {business.address.locality}, {business.address.region} {business.address.postalCode}
          </span>
          <CallLink className="sp-num" />
          <a href={business.mapLink} target="_blank" rel="noopener noreferrer">Directions</a>
        </div>
        <div className="sp-foot-col sp-num">
          <h3>Hours</h3>
          <span>Mon–Wed 11–3, 4–9</span>
          <span>Thu 11–3, 4–10</span>
          <span>Fri–Sat 11–10</span>
          <span>Sun 12–9</span>
        </div>
        <nav className="sp-foot-col" aria-label="Signature dishes">
          <h3>Dishes</h3>
          <ul>
            {dishes.map((dish) => (
              <li key={dish.slug}>
                <Link to={`/dishes/${dish.slug}`}>{dish.name}</Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav className="sp-foot-col" aria-label="Explore">
          <h3>Explore</h3>
          <ul>
            {EXPLORE.map((l) => (
              <li key={l.to}>
                <Link to={l.to}>{l.label}</Link>
              </li>
            ))}
            {SOCIAL.map((s) => (
              <li key={s.label}>
                <a href={s.href} target="_blank" rel="noopener noreferrer">{s.label}</a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="sp-foot-base">
        <span>© {new Date().getFullYear()} {business.name}</span>
        <span>{business.address.street}, {business.address.locality}, {business.address.region} {business.address.postalCode}</span>
      </div>
    </div>
  </footer>
);

export default SpFooter;
